module.exports = __webpack_public_path__ + "static/interior-db10107fdfbd26164a5be0ee960178ca.mp4";